import React from "react";
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
    fontSize: "14px",
    backgroundColor: "#7EBDCE",
    color: "#FFF",
    "&:hover": { color: "white", background: "#099F9F" },
  },
}));

function IconButton(props) {
  const classes = useStyles();
  const Icon = props.icon;

  return (
    <Button className={classes.button} startIcon={<Icon />} {...props}>
      {props.text}
    </Button>
  );
}

IconButton.propTypes = {
  icon: PropTypes.elementType,
};

export default IconButton;
